module.exports = __webpack_public_path__ + "img/PDD.492eec99.png";